import React from "react"
import features from "./features/features"
import {
  B2T_LOGO_ALT,
  B2T_LOGO_SRC,
  BRAND_LOGO_ALT,
  BRAND_LOGO_SRC,
} from "./helpers/brandLogo"
import { ReactComponent as WbencLogo } from "./images/wbencLogo.svg"
import { ReactComponent as NglccLogo } from "./images/nglccLogo.svg"
import { ReactComponent as NmsdcLogo } from "./images/nmsdcLogo.svg"
import { ReactComponent as WbencFooterLogo } from "./images/wbenc-footer-logo.svg"
import { ReactComponent as NmsdcFooterLogo } from "./images/nmsdcLogo.svg"
import { ReactComponent as NglccFooterLogo } from "./images/nglcc-footer-logo.svg"
import styles from "./components/Header/index.module.scss"
import footerStyles from "./components/Footer/Footer.module.scss"

const getCompanyLogo = () => {
  switch (features?.licenseName) {
    case "wbenc": {
      return (
        <div className={styles.headerLogo}>
          <WbencLogo className={styles.svgLogo} />
        </div>
      )
    }
    case "nglcc": {
      return (
        <div className={styles.headerLogo}>
          <NglccLogo />
        </div>
      )
    }
    case "nmsdc": {
      return (
        <div className={styles.headerLogo}>
          <NmsdcLogo className={styles.svgLogo} />
        </div>
      )
    }
    default: {
      return (
        <img
          src={BRAND_LOGO_SRC}
          alt={BRAND_LOGO_ALT}
          className={styles.headerLogoImg}
        />
      )
    }
  }
}

const PoweredByB2t = () => (
  <div className={footerStyles.poweredBy}>
    <span className={footerStyles.poweredByText}>Powered by</span>
    <img
      className={footerStyles.b2tLogo}
      src={B2T_LOGO_SRC}
      alt={B2T_LOGO_ALT}
    />
  </div>
)

const getFooterBranding = () => (
  <div className={footerStyles.brandingWrap}>
    <img
      src={BRAND_LOGO_SRC}
      className={footerStyles.footerLogo}
      alt={BRAND_LOGO_ALT}
    />
    <PoweredByB2t />
  </div>
)

const getFooterText = () => {
  switch (features?.licenseName) {
    case "wbenc": {
      return (
        <div className={footerStyles.logoSvg}>
          <WbencFooterLogo />
        </div>
      )
    }
    case "nglcc": {
      return (
        <div className={footerStyles.logoSvg}>
          <NglccFooterLogo />
        </div>
      )
    }
    case "nmsdc": {
      return (
        <div className={footerStyles.logoSvg}>
          <NmsdcFooterLogo />
        </div>
      )
    }
    default: {
      return null
    }
  }
}

export default {
  getCompanyLogo,
  getFooterBranding,
  getFooterText,
  getPoweredByB2t: () => <PoweredByB2t />,
}
